<template>
  <div class="offtaker__body">
    <!-- Sellers near you-->
    <div class="row">
      <div class="col-6 col-lg-3"
           v-for="(seller, i) in sellers"
           :key="i">
        <div class="sellers">
          <div class="top-border"></div>
          <div class="sellers__body">
            <div class="avatarBig bg__primary ">
              <span
                    class="font-bold font-lg color__white">{{seller.fullName | initials}}</span>
            </div>
            <h4 class="margin_top_md mb-2 font-bold">{{seller.fullName}}
            </h4>
            <p>
              <svg width="16"
                   height="16"
                   viewBox="0 0 16 16"
                   fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7.99992 1.33333C6.58543 1.33333 5.22888 1.89524 4.22868 2.89543C3.22849 3.89562 2.66659 5.25218 2.66659 6.66667C2.66659 8.73204 4.01041 10.7362 5.48389 12.2915C6.20699 13.0548 6.93236 13.6796 7.4777 14.1139C7.68066 14.2755 7.85793 14.4101 7.99992 14.5151C8.1419 14.4101 8.31918 14.2755 8.52213 14.1139C9.06747 13.6796 9.79284 13.0548 10.516 12.2915C11.9894 10.7362 13.3333 8.73204 13.3333 6.66667C13.3333 5.25218 12.7713 3.89562 11.7712 2.89543C10.771 1.89524 9.41441 1.33333 7.99992 1.33333ZM7.99992 15.3333C7.63012 15.888 7.62995 15.8879 7.62976 15.8878L7.62785 15.8865L7.62341 15.8835L7.60813 15.8732C7.59515 15.8644 7.57664 15.8517 7.55296 15.8353C7.50561 15.8025 7.43756 15.7547 7.35178 15.6928C7.18028 15.5689 6.93749 15.3881 6.64713 15.1569C6.06747 14.6954 5.29284 14.0286 4.51595 13.2085C2.98943 11.5972 1.33325 9.26796 1.33325 6.66667C1.33325 4.89856 2.03563 3.20286 3.28587 1.95262C4.53612 0.702379 6.23181 0 7.99992 0C9.76803 0 11.4637 0.702379 12.714 1.95262C13.9642 3.20286 14.6666 4.89856 14.6666 6.66667C14.6666 9.26796 13.0104 11.5972 11.4839 13.2085C10.707 14.0286 9.93236 14.6954 9.3527 15.1569C9.06235 15.3881 8.81955 15.5689 8.64806 15.6928C8.56228 15.7547 8.49423 15.8025 8.44688 15.8353C8.4232 15.8517 8.40469 15.8644 8.39171 15.8732L8.37643 15.8835L8.37199 15.8865L8.37058 15.8875C8.37039 15.8876 8.36972 15.888 7.99992 15.3333ZM7.99992 15.3333L8.36972 15.888C8.14579 16.0373 7.85369 16.0371 7.62976 15.8878L7.99992 15.3333Z"
                      fill="#2B700B" />
                <path fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7.99992 5.33333C7.26354 5.33333 6.66659 5.93029 6.66659 6.66667C6.66659 7.40305 7.26354 8 7.99992 8C8.7363 8 9.33325 7.40305 9.33325 6.66667C9.33325 5.93029 8.7363 5.33333 7.99992 5.33333ZM5.33325 6.66667C5.33325 5.19391 6.52716 4 7.99992 4C9.47268 4 10.6666 5.19391 10.6666 6.66667C10.6666 8.13943 9.47268 9.33333 7.99992 9.33333C6.52716 9.33333 5.33325 8.13943 5.33325 6.66667Z"
                      fill="#2B700B" />
              </svg>
              <span
                    class="ml-2 smallFont">{{`${seller.city}, ${seller.state}`}}</span>
            </p>
            <div class="divider"></div>
            <h4 class="my-2 smallFont caps_upper">Sells</h4>
            <p class="my-2">{{getCropNames(seller)}}</p>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>


<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      crops: [],
      sellers: []
    };
  },
  methods: {
    getSellers() {
      this.$http
        .get("off_takers/sellers")
        .then(({ data }) => {
          this.sellers = [...data.items];
        })
        .catch(err => {
          this.$toastr.error(err);
        });
    },
    getCropNames(seller) {
      const crops = seller.crops.map(x => x.name);

      if (crops.length > 2) {
        return crops.slice(0, 2).join(", ") + `, + ${crops.length - 2} others`;
      }

      return crops.join(", ");
    }
  },
  computed: {
    ...mapState(["user"])
  },
  created() {
    this.getSellers();
  }
};
</script>
